var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 36,
    viewBox: "0 0 42 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.4443,
    cy: 14.824,
    r: 10.6001,
    transform: "rotate(53.5532 26.4443 14.824)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.84 26.1931C29.2897 30.2922 21.7311 29.7279 16.8486 25.205L3.14868 35.3228L0 31.0594L13.7 20.9417C10.813 14.9447 12.4969 7.5542 18.0474 3.45508C24.3263 -1.18213 33.1755 0.148805 37.8127 6.42774C42.4498 12.7067 41.119 21.556 34.84 26.1931ZM17.9175 21.1213C21.3954 25.8305 28.0323 26.8287 32.7416 23.3508C37.4508 19.8729 38.449 13.236 34.9711 8.5268C31.4932 3.81757 24.8562 2.8194 20.1471 6.29724C15.4379 9.77515 14.4397 16.412 17.9175 21.1213Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.dcd8669dc18670577d480dabb9195017.svg";
export { ForwardRef as ReactComponent };